module.exports = __webpack_public_path__ + "static/media/cerebrum.5d3d1054.ogg";